/*jshint esnext: true */
/*global jQuery, dis */

/* AKQA Script
 Author's name: Dan Sørensen
 Modified by:
 Client name: Danske Regioner
 Date of creation: 19.3.2021
 */


(function ($, dis) {
	"use strict";


	dis.OkportalFavorites = function (objectConfiguration) {
		dis.BaseModule.call(this);

		var defaults = {},
			configuration = $.extend(defaults, objectConfiguration),
			dom = {},
			selfScope = this;


		function init() {
			dom.container = $(configuration.container);

			if (dom.container.length) {

				dom.profileLink = $(".okportal__profile-link");
				dom.memberId = dom.profileLink.data("memberid");

				dom.favoritesList = $(".okportal-favorites__list");

				if (dom.memberId !== undefined) {
					selfScope.getFavourites();
				}
			}
		}


		//third step
		// Function for fav
		selfScope.getFavourites = function (callback = null) {

			// Clear favorites list
			dom.favoritesList.innerHTML = "";

			const url = `${location.origin}/umbraco/api/OkPortalFavourites/GetFavourites/?memberId=${dom.memberId}`;

			const promise = Promise.resolve($.ajax({
				url: url
			}));

			const allItems = {};
			allItems.subareas = [];

			// start loading
			dom.favoritesList.addClass("-is-loading");

			// Getting all user fav & building all the data with getSubareaNodes and getAgreementbyid
			promise.then(data => {
				dom.favData = data;

				// Getting all subareas from fav contentId
				jQuery.each(dom.favData, function (index, item) {

					// const promiseSubarea = selfScope.getSubareaNodes(item.contentId);
					// promiseSubarea.then(dataSubarea => {
					//
					// 	allItems.subareas.push(dataSubarea.subarea);

						// Getting all agreements from subareas
						const promiseAgreements = selfScope.getAgreementbyid(item.contentId);
						console.log(promiseAgreements);
						promiseAgreements.then(dataAgreements => {

							// printing once at a time. because we only have a endpoint giving a fav list without the documents
							dataAgreements = selfScope.filterDocumentsInSubareaNodes(dataAgreements);
							selfScope.appendSubareaNodesDocuments(item, dataAgreements);

							// // ALL TEST
							// allItems.subareas.find(x => x.id === dataSubarea.subarea.id).documents = dataAgreements.documents;
							//
							// // First filter all documents
							// dom.filteredResponse = selfScope.filterDocumentsInSubareaNodes(allItems);
							//
							// // Render all items
							// selfScope.appendSubareaNodesDocuments(dom.filteredResponse);
						});
					// });
				});
			}).then(() => {

				if (typeof callback === "function") {
					callback();
				}
				dom.favoritesList.removeClass("-is-loading");
			}).catch(error => window.console.log(error));
		};
		selfScope.setFavourite = function (contentId, url = "") {

			const urltest = `${location.origin}/umbraco/api/OkPortalFavourites/AddFavourite/?contentId=${contentId}&memberId=${dom.memberId}`;
			if (urltest !== "") {
				url = urltest;
			}

			return Promise.resolve($.ajax({
				url: url,
				type: "POST",
			}));
		};
		selfScope.removeFavourite = function (rowId, url = "") {

			const urltest = `${location.origin}/umbraco/api/OkPortalFavourites/RemoveFavourite/?id=${rowId}`;
			if (urltest !== "") {
				url = urltest;
			}

			return Promise.resolve($.ajax({
				url: url,
				type: "DELETE",
			}));
		};
		selfScope.removeFavouriteByContentId = function (contentId, url = "") {

			const urltest = `${location.origin}/umbraco/api/OkPortalFavourites/RemoveFavouriteByContentId/?contentId=${contentId}`;
			if (urltest !== "") {
				url = urltest;
			}

			return Promise.resolve($.ajax({
				url: url,
				type: "DELETE",
			}));
		};

		selfScope.getSubareaNodes = function (subareaid = null) {

			const url = `${location.origin}/umbraco/api/okportalcontent/getsubareanodes?id=${subareaid}`;

			return Promise.resolve($.ajax({
				url: url,
				type: "GET",
				async: false,
			}));
		};
		selfScope.getAgreementbyid = function (agreementbyid = null) {

			const url = `${location.origin}/umbraco/api/okportalcontent/getagreementbyid?id=${agreementbyid}`;

			return Promise.resolve($.ajax({
				url: url,
				type: "GET",
				async: false,
				error: function (error) {
					if(JSON.parse(error.responseText).message  === "No such agreement!")
					{
						window.console.log(`Removed non-existent agreement ${agreementbyid}`);
						selfScope.removeFavouriteByContentId(agreementbyid);
					}
				}
			}));
		};
		selfScope.getSubareaNodesOld = function (subareaid = null) {

			// loading new data and running the append function

			$.ajax(`${location.origin}/umbraco/api/okportalcontent/getsubareanodes?id=${subareaid}`, {
				method: "GET",
				cache: false,
				async: false,
				success: function (response) {


					// dont have the data for this at this point
					dom.filteredResponse = selfScope.filterDocumentsInSubareaNodes(response.agreements);

					// Adding clicked item documents
					selfScope.appendSubareaNodesDocuments();


				}
			});
		};
		selfScope.getCopyUrlFromPath = function (currentFavItem, item) {
			const itemPath = item.path.split(',');

			const pathToItem = itemPath.slice(itemPath.length - 3, itemPath.length);
			const ariaId = pathToItem[0];
			const subareaId = pathToItem[1];
			const collectionName = currentFavItem.collectionName;

			return `${location.origin}/numerisk?collectionName=${collectionName}&areaid=${ariaId}&subareaid=${subareaId}&agreementid=${item.id}`;
		};
		selfScope.filterDocumentsInSubareaNodes = function (items) {

			const currentDate = new Date();

			let result = [];

			const currentDocuments = items.documents;

			const activeDocuments = currentDocuments.reduce(function (result, item) {

				const itemValidFromDate = new Date(item.validFrom);
				const itemValidToDate = new Date(item.validTo);

				if (selfScope.isValidDate(itemValidFromDate)) {
					//check if item has a valid to date if not it must be a active item, so just check if the current date is after the from date, then we know the to date isn't set yet.
					if (!selfScope.isValidDate(itemValidToDate)) {
						if (currentDate.getTime() > itemValidFromDate.getTime()) {
							result.push(item);
						}
					}
					else
					{
						// And if the item has a to date then check if the item is between the two dates.
						if (currentDate.getTime() > itemValidFromDate.getTime() && currentDate.getTime() < itemValidToDate.getTime()) {
							result.push(item);
						}
					}
				}
				return result;
			}, []);

			const futureDocuments = currentDocuments.reduce(function (result, item) {

				const itemValidFromDate = new Date(item.validFrom);

				if (selfScope.isValidDate(itemValidFromDate)) {
					if (currentDate.getTime() < itemValidFromDate.getTime()) {
						result.push(item);
					}
				}
				return result;
			}, []);

			const historyDocuments = currentDocuments.reduce(function (result, item) {

				const itemValidFromDate = new Date(item.validFrom);
				const itemValidToDate = new Date(item.validTo);

				if (selfScope.isValidDate(itemValidFromDate)) {
					if (selfScope.isValidDate(itemValidToDate)) {
						if (currentDate.getTime() > itemValidFromDate.getTime() && currentDate.getTime() > itemValidToDate.getTime()) {
							result.push(item);
						}
					}
				}
				return result;
			}, []);


			result = activeDocuments.concat(futureDocuments).concat(historyDocuments);

			items.documents = result;


			return items;
		};
		// selfScope.GetDocumentById = function (mediaNodeId) {
		//
		// 	const url = `${location.origin}/GetDocumentById?mediaNodeId=${mediaNodeId}`;
		//
		// 	return Promise.resolve($.ajax({
		// 		url: url,
		// 		type: "GET",
		// 		async: false,
		// 	}));
		// };


		selfScope.templatingSubareaDocumentWrapperItem = function (currentFavItem, item) {

			// they will all be fav because its a list of fave
			let hasItemAsFav = true;

			let documentsHtml = "";
			item.documents.forEach(function (document) {
				documentsHtml = documentsHtml + selfScope.templatingDocumentItem(document);
			});

			const copyurl = selfScope.getCopyUrlFromPath(currentFavItem, item);

			return selfScope.templating('' +
				'<li>' +
				'<div class="accordion-box__content">' +
				'<div class="accordion-box__content__item">' +
				'<input type="radio" name="accordion-{{id}}" id="{{id}}">' +
				'<label class="accordion-box__content__item__head" for="{{id}}">' +
				'<p class="item__placement"><span>Placering i indholdsfortegnelse: </span>{{mainAreaNumber}}</p>' +
				'<h2 class="item__heading">{{heading}}</h2>' +
				'<span class="icon"><svg role="img" aria-label="Op ned pil"><use xlink:href="~/static/dcoic0fh972bb0fmewhxng/static/dist/icons.svg#arrow-down"></use></svg></span>' +
				'<label><input type="radio" name="accordion-{{id}}"></label>' +
				'</label>' +
				'<div class="accordion-box__content__item__body">' +
				'<div class="accordion-box__content__item__body__inside document__wrapper">' +
				'<div class="document">' +
				'<div class="document__actions">' +
				'<div class="document__actions-col1"><a class="document__actions-showOtherMaterial" href="">Vis andet relevant materiale</a></div>' +
				'<div class="document__actions-col2">' +
				'<button class="document__actions-copyLink" data-copyUrl="{{copyurl}}">Kopier link<svg role="img" aria-label="Kopier link ikon"><use xlink:href="~/static/dcoic0fh972bb0fmewhxng/static/dist/icons.svg#link"></use></svg>' +
				'<span class="document__actions-copyLink-checkmark"><svg role="img" aria-label="Kopier link ikon checkmark"><use xlink:href="~/static/dcoic0fh972bb0fmewhxng/static/dist/icons.svg#checkmark"></use></svg></span>' +
				'</button>' +
				(dom.memberId !== undefined ? '' +
					'<button data-contentid="{{id}}" data-rowid="{{rowId}}" class="document__actions-addFavorites ' + (hasItemAsFav ? "-is-faved" : "") + '" >' +
					'<span class="add-text">Tilføj favoritter</span><span class="remove-text">Fjern favoritter</span><svg role="img" aria-label="Remove til favoritter ikon"><use xlink:href="~/static/dcoic0fh972bb0fmewhxng/static/dist/icons.svg#heart-like"></use></svg><svg role="img" aria-label="Document er tilføjet favoritter ikon"><use xlink:href="~/static/dcoic0fh972bb0fmewhxng/static/dist/icons.svg#heart-like-fill"></use></svg>' +
					'</button>' : '' +
					'<a class="document__actions-addFavorites login-button-modal open-modal" href="#login-form" >' +
					'Tilføj favoritter<svg role="img" aria-label="Tilføj til favoritter ikon"><use xlink:href="~/static/dcoic0fh972bb0fmewhxng/static/dist/icons.svg#heart-like"></use></svg><svg role="img" aria-label="Document er tilføjet favoritter ikon"><use xlink:href="~/static/dcoic0fh972bb0fmewhxng/static/dist/icons.svg#heart-like-fill"></use></svg>' +
					'</a>') +
				'</div>' +
				'</div>' +
				documentsHtml +
				'</div>' +
				'</div>' +
				'</div>' +
				'</div>' +
				'</div>' +
				'</li>'.toString(), {
				id: item.id,
				rowId: (currentFavItem !== null ? currentFavItem.id : ""),
				heading: item.name,
				mainAreaNumber: item.number,
				mainAreaHeadline: item.headline,
				areaNumber: item.areaNumber,
				areaHeadline: item.areaHeadline,
				copyurl: copyurl
			});
		};
		selfScope.templatingDocumentItem = function (item) {
			//format dates
			var validFromDate = new Date(item.validFrom);
			// getMonth counting from 0 so we have to add 1 to getMonth
			var validFromDateMonth = validFromDate.getMonth() + 1;
			var validFromDateFormated = (validFromDate.getDate() > 9 ? validFromDate.getDate() : '0' + validFromDate.getDate()) + "." + (validFromDateMonth > 9 ? validFromDateMonth : '0' + validFromDateMonth) + "." + validFromDate.getFullYear();

			var validToDate = new Date(item.validTo);
			// getMonth counting from 0 so we have to add 1 to getMonth
			var validToDateMonth = validToDate.getMonth() + 1;
			var validToDateFormated = (validToDate.getDate() > 9 ? validToDate.getDate() : '0' + validToDate.getDate()) + "." + (validToDateMonth > 9 ? validToDateMonth : '0' + validToDateMonth) + "." + validToDate.getFullYear();

			//active future or history
			var dateActivationTag = selfScope.getDateActivationText(validFromDate, validToDate);
			var activationTagText = (dateActivationTag === "--active" ? "Aktiv" : (dateActivationTag === "--history" ? "Historie" : "Fremtidig"));

			//Get Media Url
			let mediaUrl = null;
			if(item.mediaid !== null && item.mediaid !== "")
			{
				// const promise = selfScope.GetDocumentById(item.fileId);
				// promise.then(data => mediaUrl = data);

				mediaUrl = `${location.origin}/GetDocumentById?mediaNodeId=${item.mediaid}`;
			}


			return selfScope.templating('' +
				'<div class="document__inner ' + dateActivationTag + '">' +
				'<div class="document__title"><h3>{{description}}</h3></div>' +
				// '<div class="document__description">{{description}}</div>' +
				// '<div class="document__type">' +
				// '<button class="document__type-btn btn -primary">{{type}}</button>' +
				// '</div>' +
				'<div class="document__dates-wrapper">' +
				'<label class="document__dates-tag ' + dateActivationTag + '">' + activationTagText + '</label>' +
				'<div class="document__dates">' +
				(selfScope.isValidDate(validFromDate) ? '' +
					'<div class="document__dates-validFrom">' +
					'<p class="document__dates-validFrom-labels">Gyldig fra :&nbsp;</p><p class="document__dates-validFrom-date">{{validFrom}}</p>' +
					'</div>' : '') +
				(selfScope.isValidDate(validToDate) ? '' +
					'<div class="document__dates-validTo">' +
					'<p class="document__dates-validTo-labels">Gyldig til :&nbsp;</p><p class="document__dates-validTo-date">{{validTo}}</p>' +
					'</div>' : '') +
				'</div>' +
				'</div>' +
				'<div class="document__download">' +
				(mediaUrl === null ? '' : '' +
					'<a href="{{mediaUrl}}" target="_blank" class="document__download-link ' + dateActivationTag + '"><span class="document__download-text">Hent dokument</span><svg role="img" aria-label="Download pil"><use xlink:href="~/static/dcoic0fh972bb0fmewhxng/static/dist/icons.svg#download"></use></svg></a>') +
				'</div>' +
				'</div>'.toString(), {
				description: item.description,
				title: item.name,
				type: item.type,
				validFrom: validFromDateFormated,
				validTo: validToDateFormated,
				mediaUrl: mediaUrl
			});
		};
		selfScope.appendSubareaNodesDocuments = function (currentFavItem, element) {
			if (element !== null) {
					dom.favoritesList.append(selfScope.templatingSubareaDocumentWrapperItem(currentFavItem, element));
			}

			selfScope.handleCopyUrl();
			selfScope.handleFav();
		};

		selfScope.SetWindowHistoryState = function () {

			const parameterStr = jQuery.param(dom.paramsForWindowHistoryState);
			window.history.pushState('Okportal numerisk', 'Okportal numerisk', `${location.origin}${location.pathname}?${parameterStr}`);
		};

		//Set if document is active
		selfScope.getDateActivationText = function (validFromDate, validToDate) {
			var currentDate = new Date();

			if (selfScope.isValidDate(validFromDate)) {
				if (currentDate.getTime() > validFromDate.getTime()) {
					if (validToDate.getTime() > currentDate.getTime() || !selfScope.isValidDate(validToDate)) {
						return '--active';
					} else {
						return '--history';
					}
				} else {
					return '--future';
				}
			} else if (selfScope.isValidDate(validToDate))//Future
			{
				if (validToDate.getTime() > currentDate.getTime()) {
					return '--active';
				} else {
					return '--history';
				}
			} else {
				return '--future';
			}
		};

		// Check if date is valid
		selfScope.isValidDate = function (d) {
			return d instanceof Date && !isNaN(d) && d.getTime() !== new Date("0001-01-01T00:00:00").getTime() && d.getTime() !== new Date("9999-12-31T23:59:59.9999999").getTime();
		};

		selfScope.handleBackToOverviewBtn = function () {
			//back to overview btn
			dom.okportalNumeriskBackToOverviewBtn = dom.container.find(".okportal-numerisk__backToOverviewBtn");
			dom.okportalNumeriskBackToOverviewBtn.on("click", () => selfScope.handleBackToOverviewCollectionNodes());
		};
		selfScope.handleSubareaBtns = function () {
			//To make next step buttons
			dom.okportalNumeriskSubareaBtns = dom.numeriskResultsList.find(".okportal-numerisk__item-subarea");
			dom.okportalNumeriskSubareaBtns.on("click", e => {


				// Getting Favourites data
				if (dom.memberId !== undefined) {
					selfScope.getFavourites(null, "", e);
				} else {
					selfScope.getSubareaNodes(e);
				}
			});
		};
		selfScope.handleDomItemSubareaList = function () {
			//Subarealist used to append documents
			dom.okportalNumeriskSubareaList = dom.container.find(".okportal-numerisk__subarea-list");
		};
		selfScope.handleCollectionName = function () {

			// Set collectionname from page or parameter
			if ($(dom.numeriskResultsList)[0].dataset.agreementcollection !== "") {
				dom.paramsForWindowHistoryState.collectionName = $(dom.numeriskResultsList)[0].dataset.agreementcollection;
			} else {
				dom.paramsForWindowHistoryState.collectionName = dom.params.collectionName;
				dom.headline.text(`Numerisk ${dom.params.collectionName}`);
			}
		};
		selfScope.handleCopyUrl = function () {

			const copyBtns = dom.container.find(".document__actions-copyLink");
			copyBtns.on("click", e => {

				const currentBtn = $(e.currentTarget);
				currentBtn.addClass("-is-copied");
				// Find parent radioItem to get the agreementid
				// const parentItem = currentBtn.closest(".accordion-box__content__item");
				// const radioItem = parentItem.find("input[type=radio]");

				// Set current agreementid because we can have multiple open at once.
				// dom.paramsForWindowHistoryState.agreementid = radioItem.attr("id");
				// selfScope.SetWindowHistoryState();

				// Copy current page href
				var dummyInput = document.createElement('input'),
					text = currentBtn.data("copyurl");

				document.body.appendChild(dummyInput);
				dummyInput.value = text;
				dummyInput.select();
				document.execCommand('copy');
				document.body.removeChild(dummyInput);

				window.setTimeout(() => {
					currentBtn.removeClass("-is-copied");
				}, 2000);

			});
		};
		selfScope.handleFav = function () {

			const favedBtns = dom.container.find(".document__actions-addFavorites");

			if (favedBtns.prop("tagName") !== "A") {
				favedBtns.on("click", e => {
					const currentBtn = $(e.currentTarget)[0];
					const contentId = currentBtn.dataset.contentid;
					const rowId = currentBtn.dataset.rowid;
					$(currentBtn).addClass("-is-loading");


					// If element is already in fav list
					if (!$(currentBtn).hasClass("-is-faved")) {
						// Setting favourite data
						const promise = selfScope.setFavourite(contentId);
						promise.then(data => {
							currentBtn.dataset.rowid = data;
							$(currentBtn).removeClass("-is-loading");
							$(currentBtn).addClass("-is-faved");
						}).catch(error => window.console.log(error));
					} else {
						// Removeing favourite data
						const promise = selfScope.removeFavourite(rowId);
						promise.then(() => {
							currentBtn.dataset.rowid = "";
							$(currentBtn).removeClass("-is-loading");
							$(currentBtn).removeClass("-is-faved");
						}).catch(error => window.console.log(error));
					}
				});
			} else {
				const loginModal = new dis.JqueryModal();
			}
		};

		selfScope.onReady(init);
	};

	dis.OkportalFavorites.prototype = new dis.BaseModule();
	dis.OkportalFavorites.constructor = dis.OkportalFavorites;


// This is where you define the global parameters you pass into your closure. You'll want to pass in any
// big stuff you'll need inside your script. Minor stuff can always be accessed through window.someVariable.
}(jQuery, dis));





